import {NgModule} from "@angular/core";
import {NumberChangerComponent} from "./number-changer/number-changer.component";
import {SelectComponent} from "./select/select.component";
import {SliderComponent} from "./slider/slider.component";
import {CommonModule, NgOptimizedImage} from "@angular/common";
import {SliderWithNumberComponent} from "./slider-with-number/slider-with-number.component";

@NgModule({
  declarations: [
    NumberChangerComponent,
    SelectComponent,
    SliderComponent,
    SliderWithNumberComponent
  ],
  exports: [
    NumberChangerComponent,
    SelectComponent,
    SliderComponent,
    SliderWithNumberComponent
  ],
  imports: [
    CommonModule,
    NgOptimizedImage
  ]
})
export class InputModule {}
